import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

import type { UpcomingMeetingsGroupCounts } from "../upcomingMeetingsLib"

type Props = Readonly<{
    counts: UpcomingMeetingsGroupCounts
}>

export function UpcomingMeetingsGroupCount({ counts: { bookings, orders } }: Props) {
    return (
        <>
            {bookings > 0 && (
                <LocalizedStrict
                    id="service-center-reports-upcoming-meetings-group-bookings-count"
                    vars={{ count: bookings }}
                >
                    <span>{bookings} bookings</span>
                </LocalizedStrict>
            )}
            {bookings > 0 && orders > 0 && " · "}
            {orders > 0 && (
                <LocalizedStrict
                    id="service-center-reports-upcoming-meetings-group-orders-count"
                    vars={{ count: orders }}
                >
                    <span>{orders} orders</span>
                </LocalizedStrict>
            )}
        </>
    )
}
